import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import Author from './section-components/author';
import Footer from './global-components/footer';
import { Helmet } from 'react-helmet';

const AuthorPage = () => {
    return <div>
        <Helmet>
    <title>Author - Muslim's Voice Network News</title>
    <meta name="description" content="Discover articles and insights from featured authors at Muslim's Voice Network News. Explore their stories and perspectives." />
    <meta name="keywords" content="authors, Muslim blogs, articles, stories, insights" />
    <meta name="author" content="Muslim's Voice Network News" />
</Helmet>

        <Navbar />
        <PageHeader headertitle="Author"  />
        <Author />
        <Footer />
    </div>
}

export default AuthorPage

